module.exports = __webpack_public_path__ + "img/8_57.698eab8a.png";